import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import MillsCard from "../../../../src/docs/components/millscard";
import Vankooten from "../../../../src/docs/assets/profiles/vankooten.jpg";
import Pittas from "../../../../src/docs/assets/profiles/pittas.jpg";
import Powell from "../../../../src/docs/assets/profiles/powell.jpg";
import Conner from "../../../../src/docs/assets/profiles/conner.jpg";
import Clayton from "../../../../src/docs/assets/profiles/clayton.jpg";
import Ohearn from "../../../../src/docs/assets/profiles/ohearn.jpg";
import Hammond from "../../../../src/docs/assets/profiles/hammond.jpg";
import White from "../../../../src/docs/assets/profiles/white.jpg";
import Seadia from "../../../../src/docs/assets/profiles/seadia.jpg";
import Adams from "../../../../src/docs/assets/profiles/adams.jpg";
import Allred from "../../../../src/docs/assets/profiles/allred.jpg";
import Beumer from "../../../../src/docs/assets/profiles/beumer.jpg";
import Casalino from "../../../../src/docs/assets/profiles/casalino.jpg";
import Calzaretta from "../../../../src/docs/assets/profiles/calzaretta.jpg";
import Malinka from "../../../../src/docs/assets/profiles/malinka.jpg";
import Duval from "../../../../src/docs/assets/profiles/duval.jpg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  MillsCard,
  Vankooten,
  Pittas,
  Powell,
  Conner,
  Clayton,
  Ohearn,
  Hammond,
  White,
  Seadia,
  Adams,
  Allred,
  Beumer,
  Casalino,
  Calzaretta,
  Malinka,
  Duval,
  React
};